// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1__Fe","cls2":"FullScreenPremiumModal-cls2__Ug FullScreenPremiumModal-cls1__Fe"};